// extracted by mini-css-extract-plugin
export var currencyInput = "_n7-1";
export var currencySymbol = "_n7-0";